import { ProductAvailability, ProductVariant } from '@types';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const displayPrice: (price: any) => boolean = (price) => {
    return price !== undefined && price !== null && price > 0;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const displayOldPrice: (oldPrice: number | null | undefined, price: number | undefined) => boolean = (oldPrice, price) => {
    return oldPrice !== undefined && oldPrice !== null && Number(oldPrice) > 0 && Number(oldPrice) > Number(price);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const displayPromotion: (promotion: any) => boolean = (promotion) => {
    return promotion !== undefined && promotion !== null && promotion > 0 && promotion !== '0.00';
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getVariantFromAttributes: (
    attributes: { valueUuid?: string }[],
    defaultVariant: ProductVariant,
    variants?: ProductVariant[]
) => ProductVariant = (attributes, defaultVariant, variants) => {
    if (variants === undefined) {
        return defaultVariant;
    }

    const variant = variants.find((variant) => {
        const attributesUuids = (attributes.map((item) => item.valueUuid || '') || []).sort().join(',');
        const variantUuids = (variant.values?.map((item) => item.uuid || '') || []).sort().join(',');
        return attributesUuids === variantUuids;
    });

    return variant
        ? {
              price: variant?.price,
              oldPrice: variant?.oldPrice,
              points: variant?.points,
          }
        : defaultVariant;
};

export const getProductAvailability: (availability?: string) => ProductAvailability = (availability) => {
    return availability === 'out_of_stock' ? ProductAvailability.outOfStock : ProductAvailability.inStock;
};
